<!--减排方案管理-->
<template>
    <div class="jpfaGuanLiBody">
        <datePicker ref="starDatepicker" :initDate="startTime" @selectDate="selectBgDateStar" type="day"></datePicker>
        <datePicker ref="endDatepicker" :initDate="endTime" @selectDate="selectBgDateEnd" type="day"></datePicker>
        <div class="jpfaGuanLiContent" :style="getBackgroudImageStyle('huanbao/jpfaGuanLi/background.png')" v-show="isShow">
            <!--筛选框-->
            <div class="jpfaGuanLiFilter">
                <div class="jpfaGuanLiFilterLeft">
                    <span class="spanBlue">创建时间：</span>
                    <div class="jpfaGuanLiFilterLeftOn">
                        <div class="selectFrame" @click="$refs.starDatepicker.show()">
                            <span>{{ startTimeShow }}</span>
                        </div>
                        <span>到</span>
                        <div class="selectFrame" @click="$refs.endDatepicker.show()">
                            <span>{{ endTimeShow }}</span>
                        </div>
                    </div>
                </div>
                <div class="jpfaGuanLiCenter">
                    <span class="spanBlue">企业名称：</span>
                    <div class="selectFrame">
                        <input type="text" placeholder="请输入企业名称" />
                    </div>
                </div>
                <div class="jpfaGuanLiRigth">
                    <span class="spanBlue">预警等级：</span>
                    <div class="selectFrame">
                        <select>
                            <option :key="index" v-for="(item, index) in warningLevelList" :value="item">{{ item }}</option>
                        </select>
                    </div>
                    <img :src="getResourcesByName('/huanbao/jpfaGuanLi/searchFor.png')" />
                </div>
            </div>
            <div class="jpfaGuanLiList">
                <paginierung @changePage="changePageData" :pageSize="10" :currentPage="1" :pageNum="2" :titleList="titleList" :dataList="dataList">
                    <tr :key="index" v-for="(item, index) in dataList">
                        <td>{{ index + 1 }}</td>
                        <td><input type="checkbox" :id="checkboxId(index)" :value="item.pkid" class="teCheckbox" /> {{ item.type }}</td>
                        <td>{{ item.percentage }}</td>
                        <td>{{ item.startTime }}</td>
                        <td>{{ item.endTime }}</td>
                        <td>{{ item.warningLevel }}</td>
                        <td>{{ item.isEnable }}</td>
                        <td>{{ item.createTime }}</td>
                    </tr>
                </paginierung>
            </div>
        </div>
        <!--编辑及添加界面-->
        <div class="addBody" v-show="!isShow">
            <div class="addBodyTitle">
                <p>减排方案</p>
            </div>
            <div class="addBodyContent">
                <table cellpadding="0" cellspacing="0">
                    <tr>
                        <td>设置类型:</td>
                        <td>
                            <select>
                                <option value="限产">限产</option>
                                <option value="停产">停产</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td>限产百分比%:</td>
                        <td>
                            <input type="text" v-model="percentage" />
                        </td>
                    </tr>
                    <tr>
                        <td>开始时间:</td>
                        <td>
                            <div class="timeDiv">
                                <span>{{ addStartTime }}</span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>结束时间:</td>
                        <td>
                            <div class="timeDiv">
                                <span>{{ addEndTime }}</span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>预警等级:</td>
                        <td>
                            <select>
                                <option value="黄色预警">黄色预警</option>
                                <option value="橙色预警">橙色预警</option>
                                <option value="红色预警">红色预警</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td>备注:</td>
                        <td><input type="text" v-model="remark" /></td>
                    </tr>
                    <tr>
                        <td>是否启用:</td>
                        <td>
                            <input type="radio" name="drone" />
                            <span>禁用</span>
                            <input type="radio" name="drone" />
                            <span>启用</span>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>
                            <button>保存</button>
                            <button @click="isShow = true">返回</button>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import datePicker from "@/components/module/universal/datePicker.vue"
import paginierung from "@/components/module/huanbao/paginierung.vue"
export default {
    components: {
        datePicker,
        paginierung
    },
    props: {},
    data() {
        return {
            dataList: [],
            textObj: {
                type: "限产",
                percentage: "20",
                startTime: "2019-10-11 14:12:00",
                endTime: "2019-10-11 14:12:00",
                warningLevel: "黄色预警",
                isEnable: "是",
                createTime: "2019-10-11 14:12:00"
            },
            startTime: new Date(new Date().formatByDate()),
            endTime: new Date(new Date().formatByDate()),
            startTimeShow: "开始时间",
            endTimeShow: "结束时间",
            warningLevelList: ["蓝色预警", "黄色预警", "红色预警"],
            isShow: true,
            remark: "", //备注
            percentage: "", //限产百分比
            addStartTime: "开始时间",
            addEndTime: "结束时间",
            titleList: ["序号", "设置类型", "限产百分比(%)", "开始时间", "结束时间 ", "预警等级 ", "是否启用", "创建时间"]
        }
    },
    created() {},
    mounted() {
        let list = []
        for (let i = 0; i < 10; i++) {
            list.push(this.textObj)
        }
        this.dataList = list
    },
    destroyed() {},
    computed: {
        getBackgroudImageStyle() {
            return this.$store.resourcesStore.getters.getBackgroudImageStyle
        },
        getResourcesByName() {
            return this.$store.resourcesStore.getters.getResourcesByName
        },
        checkboxId() {
            return i => {
                return "checkbox" + i
            }
        }
    },
    watch: {},
    methods: {
        changePageData(index) {
            let list = []
            let len = index == 1 ? 10 : 5
            for (let i = 0; i < len; i++) {
                list.push(this.textObj)
            }
            this.dataList = list
        },
        selectBgDateStar(date) {
            this.startTime = date
            this.startTimeShow = new Date(date).format("yyyy-MM-dd")
            this.$refs.starDatepicker.hide()
        },
        selectBgDateEnd(date) {
            this.endTime = date
            this.endTimeShow = new Date(date).format("yyyy-MM-dd")
            this.$refs.endDatepicker.hide()
        },
        addClick() {
            this.isShow = false
        },
        editClick() {
            this.isShow = false
        }
    }
}
</script>

<style scoped>
.jpfaGuanLiBody {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.jpfaGuanLiContent {
    width: 98%;
    height: 92%;
}

.jpfaGuanLiFilter {
    width: 90%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    margin-top: 3.2%;
    margin-bottom: 0.1rem;
}

.jpfaGuanLiList {
    width: 90%;
    height: calc(82.5% - 0.1rem);
    margin: 0 auto;
}

.jpfaGuanLiList table {
    width: 100%;
    height: 100%;
}

.jpfaGuanLiBottom {
    height: 15%;
    width: 90%;
    display: flex;
    justify-content: space-between;
}

.jpfaGuanLiFilterLeft {
    width: 34%;
    display: flex;
    align-items: center;
    height: 100%;
}

.jpfaGuanLiFilterLeftOn {
    display: flex;
    align-items: center;
}

.spanBlue {
    color: #139ae6;
    white-space: nowrap;
}
.jpfaGuanLiFilterLeft .spanBlue {
    width: 0.6rem;
}
.jpfaGuanLiCenter .spanBlue {
    width: 0.6rem;
}
.jpfaGuanLiRigth .spanBlue {
    width: 0.8rem;
}
.jpfaGuanLiFilterLeftOn {
    width: calc(100% - 0.6rem);
}
.jpfaGuanLiFilterLeftOn .selectFrame {
    width: 50%;
    height: 0.3rem;
    border: 1px solid silver;
    padding: 0.05rem 0.05rem;
    border-radius: 0.05rem;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}

.jpfaGuanLiFilterLeftOn span {
    color: #b5b5b5;
    padding: 0 0.06rem;
}

.selectFrame span {
    color: #b5b5b5;
}

.jpfaGuanLiCenter {
    display: flex;
    align-items: center;
    width: 24%;
}

.jpfaGuanLiCenter .selectFrame {
    width: calc(100% - 0.6rem);
    border: 0;
}
.jpfaGuanLiCenter .selectFrame input {
    width: 100%;
}
.jpfaGuanLiRigth {
    display: flex;
    width: 34%;
    align-items: center;
}

.jpfaGuanLiRigth .selectFrame {
    width: calc(100% - 0.8rem);
    border: 0;
}
.jpfaGuanLiRigth select {
    border: 1px solid silver;
    border-radius: 0.05rem;
    color: #b5b5b5;
    font-size: 0.15rem;
    outline: none;
    cursor: pointer;
    padding-left: 0.1rem;
    box-sizing: border-box;
}
.jpfaGuanLiBottomLeft {
    width: 40%;
}
.jpfaGuanLiBottomLeft img {
    padding-left: 0.1rem;
}
.jpfaGuanLiRigth img {
    height: 0.3rem;
    margin-left: 0.04rem;
}
.jpfaGuanLiBottomRight {
    width: 20%;
    height: 40%;
}
.selectFrame select {
    width: 100%;
    height: 0.3rem;
    color: black;
    font-size: 0.15rem;
}

.addBody {
    width: 80%;
    height: 80%;
}

.addBodyTitle {
    width: 100%;
    height: 5%;
    background-color: #c2d4e7;
    display: flex;
    align-items: center;
}

.addBodyTitle p {
    padding-left: 0.2rem;
}

.addBodyContent {
    width: 100%;
    height: 50%;
    margin: 0 auto;
    background-color: white;
}
.addBodyContent table {
    width: 80%;
    height: 100%;
    margin: 0 auto;
}
.addBodyContent table tr td:nth-child(1) {
    width: 10%;
}
.addBodyContent table select {
    width: 100%;
    height: 80%;
    color: black;
    font-size: 0.15rem;
    border: 0.01rem solid #e5e6e7;
}
.timeDiv {
    border: 0.01rem solid #e5e6e7;
    width: 15%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.timeDiv span {
    padding: 0.05rem 0;
}
.addBodyContent table button {
    padding: 0.1rem;
    margin-left: 0.1rem;
}
.addBodyContent table button:nth-child(1) {
    background-color: #21b9bb;
    color: white;
}
.addBodyContent table button:nth-child(2) {
    border: 0.01rem;
}
</style>
